/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import NewContentList from './NewContentList'
// import moment from "moment";

import ContentItem from "../../components/event/ContentItem";

import "../../css/event210621.css";

class Event202107_contentList extends Component {
  state = {
    //eventCode: 0,
    intReturn: -101,
  };
  componentDidMount = () => {
    const eventCode = this.props.childProps.eventCode;
    this._getContentList(eventCode);
  };

  _getContentList = async (eventCode) => {
    // const { loginId } = this.props;

    // const curDate = new Date();
    // const today = moment(curDate).format("YYYY-MM-DD HH:mm:ss");

    const result = await this._getContentListApi(eventCode);
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    //console.log(contentList)

    if (intReturn === 0) {
      this.setState({
        intReturn,
        contentList,
      });
    }
  };

  _getContentListApi = (eventCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/event_202107_content", {
        params: {
          eventCode: eventCode,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };

  _renderItem = () => {
    const { contentList } = this.state;

    const list = contentList.map((item, index) => {
      return (
        <ContentItem
          key={index}
          contentSerial={item.contentSerial}
          img={item.img}
          comment={item.comment}
          title={item.title}
          alramFlag={item.alramFlag}
        />
      );
    });
    return list;
  };
  _renderNull = () => {
    const { eventCode } = this.props.childProps;
    let test = [];

    if (eventCode === 1) {
      test = [];
    } else if (eventCode === 2) {
      test = [];
    } else if (eventCode === 3) {
      test = [];
    } else if (eventCode === 4) {
      test = [];
    } else if (eventCode === 5) {
      test = [];
    }

    const list = test.map((item, index) => {
      return (
        <li key={index} style={{ width: 224, height: 502 }}>
          <div className="thumb"></div>
        </li>
      );
    });
    return list;
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  render() {
    const { intReturn, contentList } = this.state;
    const { eventCode } = this.props.childProps;

    let title = "";

    if (eventCode === 1) {
      title = "3/26";
    } else if (eventCode === 2) {
      title = "3/27";
    } else if (eventCode === 3) {
      title = "3/28";
    } else if (eventCode === 4) {
      title = "3/29";
    } else if (eventCode === 5) {
      title = "3/30";
    }
    return (
      <Fragment>
        {intReturn === 0 ? (
          <ul className="list">
            {contentList ? this._renderItem() : null}
            {contentList ? this._renderNull() : null}
          </ul>
        ) : (
          <Fragment>
            <div
              className="release"
              style={{ marginTop: eventCode === 1 ? 130 : 0 }}
            >
              MISSION OPEN : {title}
            </div>
            <ul className="list aniline">
              <li>
                <div className="ani none">
                  <img src="/img/event/20210317/null_img.png" />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src="/img/event/20210317/null_img.png" />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src="/img/event/20210317/null_img.png" />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src="/img/event/20210317/null_img.png" />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src="/img/event/20210317/null_img.png" />
                </div>
              </li>
              <li>
                <div className="ani none">
                  <img src="/img/event/20210317/null_img.png" />
                </div>
              </li>
            </ul>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202107_contentList));
